import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
/** @jsx jsx */
import styled from '@emotion/styled';
export var FlexContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export var ContentWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow-x: hidden;\n"])));